import type { Catalog } from '@/types'

export const getCatalogMetadataValue = (
  catalog?: Partial<Catalog>,
  key?: string,
): string | undefined => {
  if (!catalog || !key) return undefined

  const metadata = catalog.metadata?.find((item) => item.key === key)
  return metadata?.value != null ? String(metadata.value) : undefined
}

export const getCatalogRotorFooterLabel = (catalog?: Partial<Catalog>) =>
  getCatalogMetadataValue(catalog, 'rotorFooterLabel')
